/* RK Paket-Baukasten (21.10.2026) — Stoffpaket selbst zusammenstellen + fertige Pakete.
   Einstellungen vom Baukasten-Server (data-api), Stoffe aus /collections/<h>/products.json.
   Beim Kauf: Server prüft und legt einen Einmal-Rabattcode an → Teile in den Korb → Code einlösen.
   Der Nachlass hier ist nur Anzeige; gerechnet wird verbindlich auf dem Server. */
(function () {
  'use strict';
  const wurzel = document.querySelector('[data-bk]');
  if (!wurzel) return;
  const API = (wurzel.dataset.api || '').replace(/\/$/, '');
  const $ = (s) => wurzel.querySelector(s);
  const euro = (n) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n || 0);
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const SPEICHER = 'rk-bk-paket-v1';
  const SEITE = 24;
  const FEHLER = {
    'zu-wenig-teile': 'Dein Paket hat noch zu wenige Teile.',
    mindestwert: 'Dein Paket hat den Mindestwert noch nicht erreicht.',
    ausverkauft: 'Ein Teil ist gerade ausverkauft. Bitte nimm es aus dem Paket.',
    vorbestellung: 'Vorbestellungen können nicht ins Paket.',
    reduziert: 'Reduzierte Artikel können nicht ins Paket.',
    'passt-zu-keinem-schritt': 'Ein Teil passt nicht in den Baukasten.',
    'pflicht-fehlt': 'Ein Pflicht-Schritt fehlt noch.',
    'paket-geaendert': 'Dieses Paket hat sich gerade geändert. Bitte lade die Seite neu.',
    'zu-viele-anfragen': 'Zu viele Versuche. Bitte warte kurz.',
    'ist-paket': 'Ein fertiges Paket kann nicht Teil eines anderen Pakets sein.',
  };

  const zustand = { konfig: null, schritt: 0, produkte: new Map(), titel: new Map(), suche: '', chip: '', sichtbar: SEITE, paket: new Map() };
  try { (JSON.parse(localStorage.getItem(SPEICHER)) || []).forEach((t) => zustand.paket.set(String(t.variante), t)); } catch (e) { /* Speicher gesperrt */ }
  const sichern = () => { try { localStorage.setItem(SPEICHER, JSON.stringify([...zustand.paket.values()])); } catch (e) { /* egal */ } };

  /* Einheit aus dem Titel: „0,5m Jersey …“ → 0,5 m; sonst Stück. */
  function einheit(titel) {
    // Länge am Anfang („0,5m Jersey“) oder im Titel („Flachkordel 1m“); „8mm“ und „154 cm“ zählen nicht
    const m = /^\s*(\d+(?:[.,]\d+)?)\s?m\b/i.exec(titel || '') || /(?:^|\s)(\d+(?:[.,]\d+)?)\s?m\b/i.exec(titel || '');
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }
  const ohneEinheit = (titel) => (titel || '').replace(/^\s*\d+(?:[.,]\d+)?\s?m\b\s*/i, '');
  const mengeText = (t) => t.meter ? `${(t.meter * t.menge).toLocaleString('de-DE')} m` : `${t.menge} ×`;

  /* ───────────── Nachlass (gleiche Regel wie auf dem Server) ───────────── */
  function stufen() { return [...(zustand.konfig?.rabatt?.staffel || [])].filter((s) => s.wert > 0).sort((a, b) => a.abTeile - b.abTeile); }
  function stufeFuer(n) { return stufen().filter((s) => n >= (s.abTeile || 0)).pop() || null; }
  function nachlass(s, summe) {
    if (!s || !(summe > 0)) return 0;
    return Math.round((s.art === 'euro' ? Math.min(s.wert, summe) : summe * Math.min(s.wert, 100) / 100) * 100) / 100;
  }
  const stufeText = (s) => s.art === 'euro' ? `−${euro(s.wert)}` : `−${String(s.wert).replace('.', ',')} %`;

  /* ───────────── Daten ───────────── */
  async function json(url, opt) {
    const r = await fetch(url, opt);
    const j = await r.json().catch(() => ({}));
    if (!r.ok && !j.fehler) throw new Error('HTTP ' + r.status);
    return j;
  }
  let ausgeschlossen = null;
  async function ausschluss() {
    if (ausgeschlossen) return ausgeschlossen;
    ausgeschlossen = new Set();
    for (const h of zustand.konfig?.ausschluss?.kollektionen || []) {
      for (const p of await kollektion(h)) ausgeschlossen.add(p.handle);
    }
    return ausgeschlossen;
  }
  async function kollektion(handle) {
    const alle = [];
    for (let seite = 1; seite < 10; seite++) {
      const j = await json(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${seite}`).catch(() => ({ products: [] }));
      alle.push(...(j.products || []));
      if (!j.products || j.products.length < 250) break;
    }
    return alle;
  }
  async function kollektionsTitel(handle) {
    if (zustand.titel.has(handle)) return zustand.titel.get(handle);
    const j = await json(`/collections/${encodeURIComponent(handle)}.json`).catch(() => ({}));
    const t = j.collection?.title || handle;
    zustand.titel.set(handle, t);
    return t;
  }
  /* Ein Produkt in die Baukasten-Form bringen; null, wenn es nicht ins Paket darf. */
  function aufbereiten(p, quelle, sperre) {
    if (sperre.has(p.handle) || /vorbestell|schn[äa]ppchengl[üu]ck|n[äa]hpaket/i.test(p.title)) return null;
    const preisZahl = (x) => typeof x === 'number' ? x / 100 : parseFloat(x);
    const varianten = (p.variants || []).filter((v) => v.available !== false)
      .filter((v) => !(v.compare_at_price && preisZahl(v.compare_at_price) > preisZahl(v.price)))
      .map((v) => ({ id: String(v.id), titel: v.title === 'Default Title' ? '' : v.title, preis: preisZahl(v.price) }));
    if (!varianten.length) return null;
    const bild = p.images?.[0]?.src || p.featured_image || p.images?.[0] || '';
    return { handle: p.handle, titel: p.title, name: ohneEinheit(p.title), bild: typeof bild === 'string' ? bild : bild.src, meter: einheit(p.title), varianten, quelle };
  }
  async function schrittLaden(s) {
    if (zustand.produkte.has(s.id)) return zustand.produkte.get(s.id);
    const sperre = await ausschluss();
    const liste = [], gesehen = new Set();
    for (const h of s.kollektionen || []) {
      for (const p of await kollektion(h)) {
        if (gesehen.has(p.handle)) continue;
        const a = aufbereiten(p, h, sperre);
        if (a) { liste.push(a); gesehen.add(p.handle); }
      }
    }
    for (const h of s.produkte || []) {
      if (gesehen.has(h)) continue;
      const p = await json(`/products/${encodeURIComponent(h)}.js`).catch(() => null);
      const a = p && aufbereiten(p, '', sperre);
      if (a) { liste.push(a); gesehen.add(h); }
    }
    zustand.produkte.set(s.id, liste);
    return liste;
  }

  /* ───────────── Kopf und fertige Pakete ───────────── */
  function kopf() {
    const k = zustand.konfig;
    if (k.titel) $('[data-bk-titel]').textContent = k.titel;
    $('[data-bk-unter]').textContent = k.untertitel || '';
    $('[data-bk-staffel]').innerHTML = stufen().map((s) =>
      `<li><span>ab ${s.abTeile} Teilen</span><strong>${stufeText(s)}</strong></li>`).join('');
  }

  async function fertigePakete() {
    const pakete = zustand.konfig.pakete || [];
    if (!pakete.length) return;
    const bereich = $('[data-bk-fertig]');
    bereich.hidden = false;
    const liste = $('[data-bk-fertig-liste]');
    liste.innerHTML = pakete.map((p) => `<li class="rk-bk__fp is-laedt" data-paket="${esc(p.id)}"><div class="rk-bk__fp-bild"></div><div class="rk-bk__fp-text"><h3>${esc(p.titel)}</h3></div></li>`).join('');
    for (const p of pakete) {
      const teile = [];
      for (const t of p.teile) {
        const prod = t.handle ? await json(`/products/${encodeURIComponent(t.handle)}.js`).catch(() => null) : null;
        const v = prod?.variants?.find((x) => String(x.id) === t.variante);
        if (!v) { teile.length = 0; break; }
        teile.push({ ...t, titel: prod.title, name: ohneEinheit(prod.title), varTitel: v.title === 'Default Title' ? '' : v.title,
          preis: v.price / 100, bild: v.featured_image?.src || prod.featured_image, meter: einheit(prod.title), verfuegbar: v.available });
      }
      const el = liste.querySelector(`[data-paket="${CSS.escape(p.id)}"]`);
      if (!teile.length) { el.remove(); continue; }
      const summe = teile.reduce((a, t) => a + t.preis * t.menge, 0);
      const ab = nachlass(p.rabatt, summe);
      const lieferbar = teile.every((t) => t.verfuegbar) && !p.vorschau;
      el.classList.remove('is-laedt');
      el.innerHTML = `
        <div class="rk-bk__fp-bild">${p.bild || teile[0].bild ? `<img src="${esc(p.bild || teile[0].bild)}" alt="" loading="lazy">` : ''}
          ${ab > 0 ? `<span class="rk-bk__fp-spar">Du sparst ${euro(ab)}</span>` : ''}</div>
        <div class="rk-bk__fp-text">
          <h3>${esc(p.titel)}</h3>
          ${p.beschreibung ? `<p>${esc(p.beschreibung)}</p>` : ''}
          <ul role="list">${teile.map((t) => `<li><span>${mengeText(t)}</span> ${esc(t.name)}${t.varTitel ? ` · ${esc(t.varTitel)}` : ''}</li>`).join('')}</ul>
          <p class="rk-bk__fp-preis">${ab > 0 ? `<s>${euro(summe)}</s> ` : ''}<strong>${euro(summe - ab)}</strong></p>
          <button type="button" class="rk-btn rk-btn--haupt rk-btn--ohne-pfeil" ${lieferbar ? '' : 'disabled'}>${p.vorschau ? 'Vorschau – noch nicht im Shop' : lieferbar ? 'Paket in den Warenkorb' : 'Gerade nicht lieferbar'}</button>
          <p class="rk-bk__fehler" role="alert" hidden></p>
        </div>`;
      el.querySelector('button').addEventListener('click', (e) =>
        kaufen({ art: 'paket', paketId: p.id, teile: p.teile.map((t) => ({ variante: t.variante, menge: t.menge })), titel: p.titel },
          e.currentTarget, el.querySelector('.rk-bk__fehler')));
    }
  }

  /* ───────────── Schritte und Auswahl ───────────── */
  function schrittLeiste() {
    const schritte = zustand.konfig.schritte || [];
    $('[data-bk-schritte]').innerHTML = schritte.map((s, i) => {
      const n = [...zustand.paket.values()].filter((t) => t.schritt === s.id).length;
      return `<button type="button" role="tab" class="rk-bk__schritt" aria-selected="${i === zustand.schritt}" data-i="${i}">
        <span class="rk-bk__schritt-nr">${i + 1}</span>${esc(s.titel)}${n ? `<span class="rk-bk__schritt-zahl">${n}</span>` : ''}</button>`;
    }).join('');
  }

  async function schrittZeigen(i) {
    zustand.schritt = i; zustand.chip = ''; zustand.sichtbar = SEITE;
    const s = zustand.konfig.schritte[i];
    schrittLeiste();
    $('[data-bk-hinweis]').textContent = s.hinweis || '';
    $('[data-bk-raster]').innerHTML = Array.from({ length: 8 }, () => '<li class="rk-bk__karte is-laedt"><span class="rk-bk__bild"></span><span class="rk-bk__zeile"></span><span class="rk-bk__zeile kurz"></span></li>').join('');
    $('[data-bk-chips]').innerHTML = '';
    $('[data-bk-mehr]').hidden = true;
    await schrittLaden(s);
    if (zustand.schritt !== i) return;
    const quellen = s.kollektionen || [];
    if (quellen.length > 1) {
      const titel = await Promise.all(quellen.map(kollektionsTitel));
      $('[data-bk-chips]').innerHTML = `<button type="button" class="rk-bk__chip" aria-pressed="true" data-chip="">Alle</button>` +
        quellen.map((h, k) => `<button type="button" class="rk-bk__chip" aria-pressed="false" data-chip="${esc(h)}">${esc(titel[k])}</button>`).join('');
    }
    raster();
  }

  function raster() {
    const s = zustand.konfig.schritte[zustand.schritt];
    const alle = zustand.produkte.get(s.id) || [];
    const q = zustand.suche.trim().toLowerCase();
    const treffer = alle.filter((p) => (!zustand.chip || p.quelle === zustand.chip) && (!q || p.titel.toLowerCase().includes(q)));
    const ziel = $('[data-bk-raster]');
    if (!treffer.length) {
      ziel.innerHTML = `<li class="rk-bk__nichts">${alle.length ? 'Nichts gefunden. Probier ein anderes Wort.' : 'Hier ist gerade nichts lieferbar.'}</li>`;
      $('[data-bk-mehr]').hidden = true;
      return;
    }
    ziel.innerHTML = treffer.slice(0, zustand.sichtbar).map((p) => karte(p, s)).join('');
    $('[data-bk-mehr]').hidden = treffer.length <= zustand.sichtbar;
  }

  function karte(p, s) {
    const drin = p.varianten.find((v) => zustand.paket.has(v.id));
    const v = drin || p.varianten[0];
    const t = drin && zustand.paket.get(drin.id);
    const auswahl = p.varianten.length > 1
      ? `<select class="rk-bk__variante" aria-label="Ausführung von ${esc(p.name)}" data-variante>${p.varianten.map((x) => `<option value="${x.id}" ${x.id === v.id ? 'selected' : ''}>${esc(x.titel)}</option>`).join('')}</select>` : '';
    return `<li class="rk-bk__karte${t ? ' is-drin' : ''}" data-handle="${esc(p.handle)}" data-schritt="${esc(s.id)}">
      <span class="rk-bk__bild">${p.bild ? `<img src="${esc(p.bild)}${p.bild.includes('?') ? '&' : '?'}width=400" alt="" loading="lazy">` : ''}${t ? `<span class="rk-bk__haken" aria-hidden="true">✓</span>` : ''}</span>
      <span class="rk-bk__name">${esc(p.name)}</span>
      <span class="rk-bk__preis">${euro(v.preis)}${p.meter ? ` <small>je ${p.meter.toLocaleString('de-DE')} m</small>` : ''}</span>
      ${auswahl}
      ${t ? `<span class="rk-bk__stepper"><button type="button" data-minus="${v.id}" aria-label="Weniger">−</button><span>${mengeText(t)}</span><button type="button" data-plus="${v.id}" aria-label="Mehr">+</button></span>`
          : `<button type="button" class="rk-bk__nehmen" data-nehmen>+ Ins Paket</button>`}
    </li>`;
  }

  function produktVon(el) {
    const s = zustand.konfig.schritte.find((x) => x.id === el.dataset.schritt);
    return { s, p: (zustand.produkte.get(s.id) || []).find((x) => x.handle === el.dataset.handle) };
  }

  /* ───────────── Paket ───────────── */
  function nehmen(p, s, varianteId) {
    const v = p.varianten.find((x) => x.id === varianteId) || p.varianten[0];
    // Eine Ausführung je Produkt: Farbwechsel ersetzt die alte
    p.varianten.forEach((x) => zustand.paket.delete(x.id));
    zustand.paket.set(v.id, { variante: v.id, menge: 1, handle: p.handle, name: p.name, varTitel: v.titel, preis: v.preis, bild: p.bild, meter: p.meter, schritt: s.id });
    aendern();
  }
  function menge(id, delta) {
    const t = zustand.paket.get(id);
    if (!t) return;
    t.menge = Math.max(0, Math.min(20, t.menge + delta));
    if (!t.menge) zustand.paket.delete(id);
    aendern();
  }
  function aendern() { sichern(); paketZeigen(); schrittLeiste(); raster(); }

  function paketZeigen() {
    const teile = [...zustand.paket.values()];
    const n = teile.length;
    const summe = teile.reduce((a, t) => a + t.preis * t.menge, 0);
    const s = stufeFuer(n);
    const ab = nachlass(s, summe);
    const regeln = zustand.konfig.regeln || {};
    $('[data-bk-anzahl]').textContent = `${n} ${n === 1 ? 'Teil' : 'Teile'}`;
    $('[data-bk-leer]').hidden = n > 0;
    $('[data-bk-teile]').innerHTML = teile.map((t) => `<li class="rk-bk__teil">
      ${t.bild ? `<img src="${esc(t.bild)}${t.bild.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy">` : '<span></span>'}
      <span class="rk-bk__teil-text"><strong>${esc(t.name)}</strong>${t.varTitel ? `<small>${esc(t.varTitel)}</small>` : ''}<small>${euro(t.preis * t.menge)}</small></span>
      <span class="rk-bk__stepper rk-bk__stepper--klein"><button type="button" data-minus="${t.variante}" aria-label="Weniger ${esc(t.name)}">−</button><span>${mengeText(t)}</span><button type="button" data-plus="${t.variante}" aria-label="Mehr ${esc(t.name)}">+</button></span>
    </li>`).join('');
    const naechste = stufen().find((x) => x.abTeile > n);
    const fort = $('[data-bk-fortschritt]');
    fort.hidden = !stufen().length || !n;
    if (stufen().length) {
      const ziel = naechste ? naechste.abTeile : stufen().slice(-1)[0].abTeile;
      $('[data-bk-balken]').style.width = Math.min(100, (n / ziel) * 100) + '%';
      $('[data-bk-naechste]').innerHTML = naechste
        ? `Noch <strong>${naechste.abTeile - n} ${naechste.abTeile - n === 1 ? 'Teil' : 'Teile'}</strong> bis ${stufeText(naechste)}`
        : `<strong>${stufeText(s)} Paket-Rabatt</strong> gesichert`;
    }
    $('[data-bk-summe]').textContent = euro(summe);
    $('[data-bk-rabatt-zeile]').hidden = !(ab > 0);
    $('[data-bk-rabatt-name]').textContent = s ? `Paket-Rabatt (${stufeText(s)})` : 'Paket-Rabatt';
    $('[data-bk-rabatt]').textContent = '−' + euro(ab);
    $('[data-bk-gesamt]').textContent = euro(summe - ab);
    const zuWenig = n < (regeln.mindestTeile || 1);
    const zuKlein = summe < (regeln.mindestwert || 0);
    const knopf = $('[data-bk-kaufen]');
    knopf.disabled = zuWenig || zuKlein;
    knopf.textContent = zuWenig && n ? `Mindestens ${regeln.mindestTeile} Teile` : zuKlein && n ? `Ab ${euro(regeln.mindestwert)} Paketwert` : 'Paket in den Warenkorb';
    $('[data-bk-leiste]').hidden = !n;
    $('[data-bk-leiste-anzahl]').textContent = `${n} ${n === 1 ? 'Teil' : 'Teile'}`;
    $('[data-bk-leiste-preis]').textContent = euro(summe - ab);
  }

  /* ───────────── Kaufen ───────────── */
  async function kaufen(auftrag, knopf, fehlerEl) {
    const alt = knopf.textContent;
    fehlerEl.hidden = true;
    knopf.disabled = true;
    knopf.textContent = 'Wird geprüft …';
    try {
      const e = await json(API + '/einloesen', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ art: auftrag.art, paketId: auftrag.paketId, teile: auftrag.teile }) });
      if (!e.ok) throw new Error(FEHLER[e.fehler] || 'Das Paket konnte nicht geprüft werden. Bitte versuch es noch einmal.');
      knopf.textContent = 'Kommt in den Warenkorb …';
      const kennung = 'p' + Date.now().toString(36);
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: auftrag.teile.map((t) => ({ id: Number(t.variante), quantity: t.menge,
          properties: { Stoffpaket: auftrag.titel, _rk_paket: kennung } })) }) });
      const hinzu = await r.json();
      if (!r.ok || hinzu.status) throw new Error(hinzu.description || 'Ein Teil konnte nicht in den Warenkorb.');
      const korb = await json('/cart.js');
      const codes = (korb.discount_codes || []).map((d) => d.code).filter(Boolean);
      if (e.code) codes.push(e.code);
      const schublade = document.querySelector('cart-drawer');
      const neu = await json('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: [...new Set(codes)].join(','), sections: schublade ? ['cart-drawer', 'cart-icon-bubble'] : [], sections_url: location.pathname }) });
      if (auftrag.art === 'baukasten') { zustand.paket.clear(); aendern(); }
      knopf.textContent = alt;
      knopf.disabled = false;
      document.dispatchEvent(new CustomEvent('rk:warenkorb-geaendert'));
      if (schublade && neu.sections) { schublade.classList.remove('is-empty'); schublade.renderContents(neu); }
      else location.href = '/cart';
    } catch (fehler) {
      fehlerEl.textContent = fehler.message;
      fehlerEl.hidden = false;
      knopf.textContent = alt;
      knopf.disabled = false;
    }
  }

  /* ───────────── Ereignisse ───────────── */
  wurzel.addEventListener('click', (ev) => {
    const b = ev.target.closest('button');
    if (!b || !wurzel.contains(b)) return;
    if (b.matches('.rk-bk__schritt')) return schrittZeigen(Number(b.dataset.i));
    if (b.matches('[data-chip]')) {
      zustand.chip = b.dataset.chip; zustand.sichtbar = SEITE;
      wurzel.querySelectorAll('[data-chip]').forEach((c) => c.setAttribute('aria-pressed', String(c === b)));
      return raster();
    }
    if (b.matches('[data-mehr]')) { zustand.sichtbar += SEITE; return raster(); }
    if (b.dataset.plus) return menge(b.dataset.plus, 1);
    if (b.dataset.minus) return menge(b.dataset.minus, -1);
    if (b.matches('[data-nehmen]')) {
      const el = b.closest('.rk-bk__karte');
      const { s, p } = produktVon(el);
      return nehmen(p, s, el.querySelector('[data-variante]')?.value);
    }
    if (b.matches('[data-bk-kaufen]')) {
      const teile = [...zustand.paket.values()];
      return kaufen({ art: 'baukasten', teile: teile.map((t) => ({ variante: t.variante, menge: t.menge })), titel: 'Selbst zusammengestellt' }, b, $('[data-bk-fehler]'));
    }
    if (b.matches('[data-bk-zum-paket]')) return $('[data-bk-paket]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  wurzel.addEventListener('change', (ev) => {
    const sel = ev.target.closest('[data-variante]');
    if (!sel) return;
    const el = sel.closest('.rk-bk__karte');
    const { s, p } = produktVon(el);
    if (el.classList.contains('is-drin')) nehmen(p, s, sel.value);
  });
  let warte;
  $('[data-bk-suche]').addEventListener('input', (ev) => {
    clearTimeout(warte);
    warte = setTimeout(() => { zustand.suche = ev.target.value; zustand.sichtbar = SEITE; raster(); }, 180);
  });

  /* ───────────── Start ───────────── */
  (async function start() {
    try {
      // Vorschau eines ausgeschalteten Pakets: ?paket_vorschau=<Kennung> (Link aus der Einstellungsseite)
      const vorschau = new URLSearchParams(location.search).get('paket_vorschau');
      zustand.konfig = await json(API + '/konfig' + (vorschau ? '?vorschau=' + encodeURIComponent(vorschau) : ''));
    } catch (e) {
      $('[data-bk-bau]').innerHTML = '<p class="rk-bk__nichts">Der Baukasten ist gerade nicht erreichbar. Bitte versuch es später noch einmal.</p>';
      return;
    }
    kopf();
    if (zustand.konfig.aktiv === false || !(zustand.konfig.schritte || []).length) $('[data-bk-bau]').hidden = true;
    else { paketZeigen(); schrittZeigen(0); }
    fertigePakete();
  })();
})();
